/**
 * Module dependencies.
 */

import React, { useMemo } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CrudList } from 'app/components/organisms/crud/crud-list';
import { Button } from 'app/components/atoms/button/button';
import { resolveAppPath } from 'app/core/utils/url-resolver';
import { appRoutes } from 'app/routes';
import { createMissingDrugOccurrencesTemplate } from './form-config';
import { AiOutlineSwap } from 'react-icons/ai';

/**
 * Export `MissingDrugDetail` component.
 */

export function MissingDrugDetail(): JSX.Element {
  const [translate] = useTranslation();
  const { code } = useParams<{ code: string }>();
  const template = useMemo(() => createMissingDrugOccurrencesTemplate(translate, code ?? ''), [translate, code]);

  const convertLink = resolveAppPath(appRoutes.dashboard.medical.missingDrugsConvert as any, { code });

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
        <h2 style={{ margin: 0 }}>{code}</h2>

        {code && (
          <Link to={convertLink}>
            <Button icon={<AiOutlineSwap />}>{translate('common.actions.add')}</Button>
          </Link>
        )}
      </div>

      <CrudList template={template} />
    </div>
  );
}
